import React from "react";
import Enrolment from "../Enrolment";

const EnrolledComponent = () => {
  return <Enrolment status="enrolled" title="enrolled" />;
};
export default EnrolledComponent;
